// components/admin/AdminPanel.jsx

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "../context/AuthContext";

const AdminPanel = () => {
  const { isAdmin, fetchWithAuth, accessToken } = useAuth();
  const navigate = useNavigate();
  const [mandanten, setMandanten] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const fetchMandanten = async () => {
      try {
        const response = await fetchWithAuth(`/api/admin/mandanten/`, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) throw new Error("Fehler beim Laden der Mandanten");

        const data = await response.json();
        setMandanten(Array.isArray(data) ? data : data.results || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (isAdmin && accessToken) {
      fetchMandanten();
    }
  }, [isAdmin, accessToken]);

  if (!isAdmin) {
    return <p style={{ color: "red" }}>Zugriff verweigert – nur für Admins</p>;
  }

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Möchtest du den Mandanten "${name}" wirklich löschen?`)) return;

    try {
      const response = await fetchWithAuth(`/api/admin/mandanten/${id}/delete/`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          },
      });

      const data = await response.json();

      if (!response.ok) throw new Error(data.error || "Fehler beim Löschen");

      setErrorMessage(`✅ Mandant "${name}" erfolgreich gelöscht.`);
      setMandanten((prev) => prev.filter((m) => m.id !== id));
    } catch (err) {
      setErrorMessage("❌ " + err.message);
    }
  };

  return (
    <div className="container d-flex justify-content-center mt-5">
      <div
        className="card shadow-sm p-4"
        style={{
          maxWidth: '700px',
          width: '100%',
          backgroundColor: 'white'
        }}
      >
      <h3 className="mb-4 text-center">Admin-Panel</h3>
      <h2>Adminbereich</h2>
      <p>Verwalte Mandanten & Benutzer</p>

      <button
        className="Button"
        onClick={() => navigate("/admin/mandant-anlegen")}
      >
        Neuer Mandant
      </button>

      <h3 style={{ marginTop: "40px" }}>Alle Mandanten</h3>

      {errorMessage && (
        <div className="error-message text-red-600 mb-4">
          <span className="error-message-icon">⚠️ </span>
          <span>{errorMessage}</span>
        </div>
      )}

      {loading ? (
        <p>Lade Mandanten...</p>
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : (
        <table align="center" cellPadding="8">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
            </tr>
          </thead>
          <tbody>
            {mandanten.map((m) => (
              <tr key={m.id}>
                <td>{m.id}</td>
                <td>{m.name}</td>
                <td>
                  <button
                    className="Button"
                    style={{ backgroundColor: "#dc3545", color: "white" }}
                    onClick={() => handleDelete(m.id, m.name)}
                  >
                    Löschen
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <br />
      <button
        className="Button"
        style={{ backgroundColor: "#6c757d" }}
        onClick={() => navigate("/objekte")}
      >
        Zurück zur Objektliste
      </button>
    </div>
  </div>
  );
};

export default AdminPanel;
